import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ViduraSearchAnswer = ({ q, compact = false, onNavigate }) => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(false);
  useEffect(() => {
    if (!q || q.trim().length < 3) return;
    setBusy(true); setErr(false); setD(null);
    const ctl = new AbortController();
    fetch(`${API}/site-search/ask`, { method: "POST", headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: JSON.stringify({ q: q.trim() }), signal: ctl.signal })
      .then(async (r) => { if (!r.ok) { const j = await r.json().catch(() => ({})); const e = new Error(j.detail || String(r.status)); e.status = r.status; throw e; } return r.json(); })
      .then(setD).catch((e) => { if (e.name !== "AbortError") setErr(e.status === 429 ? e.message : true); }).finally(() => setBusy(false));
    return () => ctl.abort();
  }, [q]);
  if (!q || q.trim().length < 3) return null;
  return (
    <div className={`border border-gf-primary/30 bg-gf-primary/5 ${compact ? "px-4 py-3" : "p-5 mt-4"}`} data-testid="vidura-search-answer">
      <p className="font-mono text-[9px] uppercase tracking-wider text-gf-primary flex items-center gap-1.5"><Sparkles className="w-3 h-3" /> Vidura answers</p>
      {busy && <p className="font-body text-xs text-gf-muted mt-2 flex items-center gap-2" data-testid="vidura-search-busy"><Loader2 className="w-3 h-3 animate-spin" /> Thinking about “{q}”…</p>}
      {err && <p className="font-body text-xs text-gf-muted mt-2" data-testid="vidura-search-error">{typeof err === "string" ? err : "Vidura is busy right now — try the links in the menu or ask again in a minute."}</p>}
      {d && (
        <>
          <p className={`font-body ${compact ? "text-xs" : "text-sm"} text-gf-text mt-2 leading-relaxed`} data-testid="vidura-search-text">{d.answer}</p>
          {d.links?.length > 0 && (
            <div className="mt-2 flex flex-wrap gap-1.5">
              {d.links.map((l, i) => (
                <Link key={l.href + i} to={l.href} onClick={onNavigate} data-testid={`vidura-search-link-${i}`} title={l.why || ""}
                  className="font-body text-[11px] border border-white/15 px-2 py-1 text-gf-text hover:border-gf-primary/60 hover:text-gf-primary transition-colors">{l.title} →</Link>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};
